import { Professional, ProfessionalUpdatePayload, ProfessionalCreatePayload } from '../types/professional';

const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

function getAuthHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

export async function getProfessionalsByAgent(agentId: string): Promise<Professional[]> {
  const response = await fetch(`${API_BASE_URL}/Professional/GetByAgent/${agentId}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch professionals');
  }
  return response.json();
}

export async function createProfessional(
  agentId: string,
  payload: ProfessionalCreatePayload
): Promise<Professional> {
  const response = await fetch(`${API_BASE_URL}/Professional/CreateForAgent/${agentId}`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.message || 'Failed to create professional');
  }
  return response.json();
}

export async function updateProfessional(
  professionalId: string,
  payload: ProfessionalUpdatePayload
): Promise<Professional> {
  const response = await fetch(`${API_BASE_URL}/Professional/Update/${professionalId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.message || 'Failed to update professional');
  }
  return response.json();
}

export async function syncAllProfessionalsFromTrinks(agentId: string): Promise<{ message: string }> {
  const response = await fetch(`${API_BASE_URL}/Professional/SyncAllFromTrinks/${agentId}`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || 'Failed to sync professionals from Trinks');
  }
  return data;
}

export async function syncOneProfessionalFromTrinks(
  agentId: string,
  professionalId: string
): Promise<{ message: string }> {
  const response = await fetch(
    `${API_BASE_URL}/Professional/SyncOneFromTrinks/${agentId}/${professionalId}`,
    {
      method: 'POST',
      headers: getAuthHeaders(),
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || 'Failed to sync professional from Trinks');
  }
  return data;
}
